import { Map, OrderedSet, OrderedMap } from 'immutable';
import { records as jobRecords } from '@saucelabs/sl-module-archived-jobs';
import { format } from 'date-fns';

import * as constants from './constants';
import * as helpers from './helpers';
import * as types from './types';
import { types as containerTypes } from './../container';
import { getTeamLabelsMap } from '../container/utils';

/* eslint no-underscore-dangle: 0, id-length: 0, no-unused-vars: 0 */
const { startDate, endDate } = helpers.getAssetsTimeOffset();

export const initialState = Map({
  error: null,
  filters: constants.FILTERS_MAP.concat(constants.XTM_FILTERS_MAP).mapEntries(([key, value]) => ([
    value.toLowerCase(),
    Map({
      loading: false,
      items: OrderedSet(),
      labels: null,
      selectedItems: OrderedSet(),
    }),
  ])),
  filterDate: Map({
    startDate,
    endDate,
  }),
  results: OrderedMap(),
  loading: true,
  inputQuery: '',
  query: Map({
    page: 0,
    q: '',
    sort: null,
    start: Math.floor(endDate / 1000),
    owner: null,
    team_id: null,
  }),
  total: 0,
}).setIn(['filters', 'status', 'items'], OrderedSet(['Passed', 'Failed', 'Complete', 'Error']));

const queryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SEARCH.REQUEST:
      return state
        .set('loading', true);
    case types.UPDATE_QUERY:
      return state
        .set('inputQuery', payload || '')
        .set('results', initialState.get('results'));
    case types.SEARCH.FAILURE: {
      return state
        .set('loading', false)
        .set('error', payload);
    }
    case types.FETCH_FACET.REQUEST:
      return state.setIn(['filters', payload.name, 'loading'], true);
    case types.FETCH_FACET.SUCCESS: {
      const items = payload.aggregations.field_facets.buckets.map((el) => el.key);
      const oldValues = state.getIn(['filters', payload.facetName, 'items']);
      const newValues = OrderedSet(items);
      return state.withMutations((newState) => {
        newState
          .setIn(['filters', payload.facetName, 'items'], oldValues.union(newValues))
          .setIn(['filters', payload.facetName, 'loading'], false);
      });
    }
    case types.FETCH_FACET.FAILURE:
      // skipping this error for now as it does not prevent user from anything
      return state.setIn(['filters', payload.name, 'loading'], false);
    case types.UPDATE_FACET_VALUE: {
      const oldValues = state.getIn(['filters', payload.name, 'items']);
      const newValues = OrderedSet(payload.data.items);
      return state.withMutations((newState) => {
        newState
          .setIn(['filters', payload.name, 'selectedItems'], payload.data.items)
          .setIn(['filters', payload.name, 'items'], oldValues.union(newValues));
      });
    }
    case types.UPDATE_DATE_FACET:
      return state.set('filterDate', payload);
    case types.UPDATE_SORT:
      return state
        .setIn(['query', 'sort'], payload)
        .set('results', initialState.get('results'));
    case types.INCREMENT_PAGE: {
      const currentPage = state.getIn(['query', 'page']);
      return state.setIn(['query', 'page'], currentPage + 1);
    }
    case types.RESET_PAGE:
      return state.setIn(['query', 'page'], 0);
    case types.TEAMLIST_GET.SUCCESS:
      return state.withMutations((mutable) => (
        mutable
          .setIn(['filters', 'teams', 'items'], OrderedSet(payload.results.map((team) => team.id)))
          .setIn(['filters', 'teams', 'labels'], getTeamLabelsMap(payload.results))
      ));
    case types.EXTEND_FACET:
      return state.withMutations((newState) => {
        newState.setIn(['filters', payload.name, 'items'], OrderedSet(payload.items));
        if (payload.labels) {
          newState.setIn(['filters', payload.name, 'labels'], payload.labels);
        }
      });
    case types.SEARCH.SUCCESS: {
      const currentResults = state.get('results');
      const {
        hits: jobs,
        total: { value: totalJobs },
      } = payload.hits;
      const newResults = OrderedMap().withMutations((mutable) => (
        jobs.reduce((acc, item) => acc.set(
          item._id, new jobRecords.ArchivedJobRecord({ ...item._source, id: item._id }),
        ), mutable)
      ));

      const results = newResults.sort((one, two) => one.get('date') - two.get('date'));

      return state.withMutations((newState) => {
        newState
          .set('results', results)
          .set('loading', false)
          .set('error', null)
          .set('total', totalJobs);
      });
    }
    case types.CHANGE_PAGE: {
      return state.setIn(['query', 'page'], payload);
    }
    case containerTypes.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default queryReducer;
